import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { DateFilter, EntryStatus } from '@app/pages/link/manager/components/FilterModal';
import { userScopedStorage } from './userScopedStorage';

type EventFiltersState = {
  siteIds: number[];
  formUids: string[];
  groupIds: number[];
  dateFilter: DateFilter;
  status: EntryStatus;
  importances: number[];
  saveFilters: (
    siteIds: number[],
    formUids: string[],
    groupIds: number[],
    dateFilter: DateFilter,
    status: EntryStatus,
    importances: number[]
  ) => void;
  clearFilters: () => void;
};

const INITIAL_STATE = {
  siteIds: [] as number[],
  formUids: [] as string[],
  groupIds: [] as number[],
  dateFilter: null as DateFilter,
  status: null as EntryStatus,
  importances: [] as number[]
};

export const useEventFiltersStore = create<EventFiltersState>()(
  devtools(
    persist(
      (set) => ({
        ...INITIAL_STATE,
        saveFilters: (siteIds, formUids, groupIds, dateFilter, status, importances) =>
          set({ siteIds, formUids, groupIds, dateFilter, status, importances }),
        clearFilters: () => set(INITIAL_STATE)
      }),
      {
        name: 'event-filters',
        storage: userScopedStorage<EventFiltersState>(),
        // Sans userId, on ne lit rien : l'hydratation est déclenchée
        // manuellement par le flux d'auth via `setUserScope` + `rehydrate`.
        skipHydration: true
      }
    ),
    { name: 'EventFiltersStore', enabled: process.env.NODE_ENV === 'development' }
  )
);

/** Reset complet du store en mémoire (à appeler au logout). */
export const resetEventFiltersStore = () => {
  useEventFiltersStore.setState(INITIAL_STATE);
};
